import { Node, HasCheck } from './node';
let _AutoTerminal = false;
export const autoTerminalAware = (fn) => {
    const prevAutoTermial = _AutoTerminal;
    _AutoTerminal = true;
    try {
        const result = fn();
        return result;
    }
    finally {
        _AutoTerminal = prevAutoTermial;
    }
};
export const noAutoTerminal = (fn) => {
    const prevAutoTermial = _AutoTerminal;
    _AutoTerminal = false;
    try {
        const result = fn();
        return result;
    }
    finally {
        _AutoTerminal = prevAutoTermial;
    }
};
export const isAutoTerminal = () => _AutoTerminal;
const MUTABLE_METHODS = new Map();
MUTABLE_METHODS.set(Array, { splice: true, copyWithin: true, pop: true, push: true, shift: true, unshift: true, reverse: true, sort: true });
export class ObservableNode extends Node {
    $at(k, creator) {
        let entry = this._entries[String(k)];
        if (!entry) {
            let value = this._memoValue ? this._memoValue[k] : null;
            // if (value && typeof value.$at === 'function') {
            //     value = value.$value
            // }
            entry = creator ? creator(this, k) : this._createEntry(value, k);
            // FIXME
            entry._uid = this._uidFunc(value);
            //            entry = proxify(entry.$value, entry)
            this._entries[String(k)] = entry;
        }
        return entry; // FIXME
    }
    $has(key, check) {
        const v = this.$value;
        if (v != null && v[key] != null) {
            if (check == HasCheck.METHOD) {
                return typeof v[key] === 'function';
            }
            return true;
        }
        return false;
    }
    $is(ctor) {
        return ctor == this._memoValue.constructor;
        // if (check == IsCheck.ARRAY && Array.isArray(this._memoValue)) {
        //     return true
        // }
        // return false
    }
    $ownKeys() {
        const v = this.$value;
        return typeof v == 'object' ? Reflect.ownKeys(v) : [];
    }
    $getOwnPropertyDescriptor(name) {
        const v = this.$value;
        return (typeof v == 'object') ? Reflect.getOwnPropertyDescriptor(v, name) : undefined;
    }
    _createEntry(value, key) {
        return proxify(value, new ObservableNode(value, this, key));
    }
}
export const observable = (initValue, uidFunc) => {
    const value = isValueSet(initValue) ? initValue.$value : initValue;
    return proxify(value, new ObservableNode(value, null, null, uidFunc));
};
export const reactive = (initValue, uidFunc) => {
    const value = isValueSet(initValue) ? initValue.$value : initValue;
    return proxify(value, new ObservableNode(value, null, null, uidFunc));
};
// export const iterable = <T>(initValue: ObservableValueSet<T>|T, uidFunc: UidFunc) : ObservableValueSet<T>&T => {
//     return observable(initValue, uidFunc)
// }
export const isObservable = (v) => {
    return v != null && typeof v.$subscribe === 'function';
    // if (v != null) {
    //     if (v[__isProxy]) {
    //         return '$subscribe' in v
    //     }
    //     else {
    //         return v.$subscribe != null
    //     }
    // }
    // return false
    //    return v != null && (v as Observable<any>).$subscribe != undefined
};
export const isValueSet = (v) => {
    return v != null && typeof v.$at === 'function';
    // if (v != null) {
    //     if (v[__isProxy]) {
    //         return '$at' in v
    //     }
    //     else {
    //         return v.$at != null
    //     }
    // }
    return false;
};
export const isValueIterator = (v) => {
    if (v != null) {
        if (v[__isProxy]) {
            return 'next' in v;
        }
        else {
            return v.next != null;
        }
    }
    return false;
};
// const ownProps: Set<string|number|symbol> = new Set(['$key', '$value', '$uid', '$source'])
// console.log(Object.getOwnPropertyNames(new ProxyObservableNode()))
export const __isProxy = Symbol('__isProxy');
export const __isValue = Symbol('__isValue');
export const proxify = (obj, node) => {
    const proxy = new Proxy(node, {
        get(target, name) {
            // if (name == __isProxy) {
            //     return true
            // }
            if (name == '_raw') {
                debugger;
            }
            //            console.log(name, name in target)
            // собственные свойства
            if (name in target) {
                const v = target[name];
                if (v && typeof v === 'function') {
                    return v.bind(target);
                }
                return v;
            }
            //             if (target.$is(IsCheck.ARRAY)) {
            // //                console.log('array', target.$value, name)
            //                 return (target.$value as any)[name]
            //             }
            //             if (target.$is(IsCheck.ARRAY)) {
            //                 console.log(target.$value.constructor)
            //                 if (name == 'splice') {
            //                     const v = target.$value as any
            //                     return (...args: any) => {
            // //                        debugger
            //                         const out = v[name].apply(v, args)
            //                         target.$value = v
            //                         return out
            //                     }
            //                 }
            //             }
            if (target.$has(name, HasCheck.METHOD)) {
                const v = target.$value;
                if (MUTABLE_METHODS.has(v.constructor)) {
                    if (MUTABLE_METHODS.get(v.constructor)[name]) {
                        return (...args) => {
                            const out = v[name].apply(v, args);
                            target.$value = v;
                            return out;
                        };
                    }
                }
                return v[name].bind(v); //proxy)
            }
            // if (!target.$has(name)) {
            //     return undefined
            // }
            const entry = target.$at(name);
            if (_AutoTerminal && entry.$isTerminal) {
                //                console.log('terminal', name, target)
                return entry.$value;
            }
            //            console.log('ENTRY')
            return entry;
        },
        set: (target, name, v) => {
            if (name in target) {
                target[name] = v;
            }
            else {
                target.$at(name).$value = v;
            }
            return true;
        },
        ownKeys: (target) => {
            //            console.log('KEYS')
            //            const v = target.$value
            // if (v == null) {
            //     return []
            // }
            return target.$ownKeys(); //.concat(Object.keys(target))
        },
        has: (target, name) => {
            //            const v = target.$value
            //            console.log('HAS', v, name)
            // if (v == null) {
            //     return false
            // }
            // if (typeof v === 'number') {
            //     return name in Number.prototype
            // }
            // if (typeof v === 'boolean') {
            //     return name in Boolean.prototype
            // }
            return Reflect.has(target, name) || target.$has(name); // Reflect.has(v as any, name)
            //return target.$value != null && (name in target.$value)
            //return true
        },
        getOwnPropertyDescriptor: (target, name) => {
            //            console.log(name, target)
            // if (target.$value == null) {
            //     return {}
            // }
            const pd = Reflect.getOwnPropertyDescriptor(target, name) || target.$getOwnPropertyDescriptor(name); // Reflect.getOwnPropertyDescriptor(target.$value as any, name)
            pd.configurable = true;
            return pd;
        },
        apply: (target, thisArg, args) => {
            return target.$call(thisArg, args);
            // const f = (target.$value as any)
            // f.$emit('before', args)
            // return (target.$value as any).apply(thisArg, args)
        }
        // getPrototypeOf: (target) : object => {
        //     console.log('get prototype of')
        //     return Reflect.getPrototypeOf(target.$value as any)
        //     // console.log('prototype of')
        //     // if (typeof target.$value === 'number') {
        //     //     return Number.prototype
        //     // }
        //     // return Object.getPrototypeOf(target.$value)
        // }
    });
    return proxy;
};
